import { formatArea } from '@/lib/spaceUnit'

export default {
  inject: { companyBaseData: { default: () => ({}) } },
  methods: {
    formatArea(sqm) {
      return formatArea(sqm, this.companyBaseData?.country)
    },
  },
}
